// extracted by mini-css-extract-plugin
export default {"vk-auth-button":"VKAuthButton_vk-auth-button__j8E77"};